import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import type { PrefetchPublicCategoryQuery } from 'apollo-gql'
import { PREFETCH_PUBLIC_CATEGORY } from 'graphql/queries/getPublicCategoryQuery'
import { currentMarketIdVar } from 'graphql/reactive'

const prefetchCategory = async (
  apolloClient: ApolloClient<NormalizedCacheObject>,
  { slug }: { slug: string | string[] },
): Promise<PrefetchPublicCategoryQuery | undefined> => {
  const marketId = currentMarketIdVar()

  if (!marketId) {
    return undefined
  }

  const response = await apolloClient.query({
    query: PREFETCH_PUBLIC_CATEGORY,
    variables: {
      marketId,
      slug,
    },
  })

  return response.data?.market?.category
}

export default prefetchCategory
